import dayjs from "dayjs";
import { DesktopTimePicker } from "@mui/x-date-pickers";

/**
 * Time-only field on top of MUI X, hermano de DateField pero para el caso de
 * "solo hora" (ej. la hora de actuación de un conjunto dentro de una etapa,
 * donde la fecha ya la fija la etapa). Habla en string "HH:MM" en vez de
 * `Date` — es el formato en el que ya se guarda `fechaHora` en ese dominio,
 * reemplaza el time-picker artesanal a base de regex de EtapasConcurso.jsx.
 */
export const TimeField = ({
  value,
  onChange,
  label,
  ariaLabel,
  size = "small",
  error,
  helperText,
  disabled = false,
  className = ""
}) => {
  const parsed = value && /^\d{2}:\d{2}$/.test(value) ? dayjs(value, "HH:mm") : null;

  return (
    <div className={className}>
      <DesktopTimePicker
        label={label}
        value={parsed}
        onChange={newValue =>
          onChange?.(newValue?.isValid() ? newValue.format("HH:mm") : null)
        }
        ampm={false}
        disabled={disabled}
        slotProps={{
          textField: {
            size,
            error,
            helperText,
            fullWidth: true,
            inputProps: ariaLabel ? { "aria-label": ariaLabel } : undefined
          }
        }}
      />
    </div>
  );
};

export default TimeField;
